export const SOURCE_META = {
  adzuna: { label: "Adzuna", home: "https://www.adzuna.co.uk/", attr: ["Jobs", "Adzuna"], by: true },
  reed: { label: "Reed", home: "https://www.reed.co.uk/", attr: ["Jobs sourced from", "Reed.co.uk"], by: false },
  govuk: { label: "GOV.UK Apprenticeship", home: "https://www.findapprenticeship.service.gov.uk/", attr: ["Apprenticeship adverts from", "Find an apprenticeship (GOV.UK)"], by: false },
  cvlibrary: { label: "CV-Library", home: "https://www.cv-library.co.uk/", attr: ["Advertised via", "CV-Library"], by: false },
  nhs: { label: "NHS Jobs", home: "https://www.jobs.nhs.uk/", attr: ["Vacancies from", "NHS Jobs"], by: false },
};

export const sourceMeta = (source) =>
  SOURCE_META[source] || { label: "Partner", home: "#", attr: ["Jobs", "partner"], by: true };
